// extracted by mini-css-extract-plugin
export default {"inputLabel":"Label-module__inputLabel--EMji4"};